module.exports = __webpack_public_path__ + "img/right01-5.6b2bc488.png";